export const SearchClear = () => {
    const searchInputs = document.querySelectorAll('.search-form__field');

    searchInputs.forEach((input) => {
        const clearButton = document.createElement('button');
        clearButton.className = 'clear-button';
        clearButton.textContent = 'Clear';
        clearButton.type = 'button';

        input.parentNode.appendChild(clearButton);

        input.addEventListener('input', function() {
            clearButton.style.display = this.value ? 'block' : 'none';
        });

        clearButton.addEventListener('click', function() {
            event.preventDefault();
            input.value = '';
            clearButton.style.display = 'none';
        });
    });
}
